const en_US = {
    rules: {
        title: 'Rules',
        content1: `Midafi DAO is the world's first campaign autonomous anonymous DAO organization.

Midafi DAO was founded based on Midafi platform. It is integrated into the Web3.0 network, adheres to the decentralized autonomous blockchain spirit, adheres to the principle of co construction, co governance and sharing, and aspires to become the world's best meta universe digital ecological co creation platform.

Midafi players can promote Midafi mining through MPM, and pledge Midafi mining through Midafi Staking.

In the constantly evolving and upgrading meta universe, Midafi will continue to expand the new blockchain digital ecology, where NFT, DID, games, DEX, aggregators, etc. will gradually converge. Players will use this stack to create their own meta universe digital life circle; To meet (gather) friends and create a wonderful digital social circle.

In the spirit of autonomy, voluntariness and freedom, players regularly elect Midafi DAO leaders in the form of voting. The director of the league shall coordinate, coordinate and serve the players, and can be reelected and reappointed to promote Midafi.

Players can get incentive income from Midafi community construction fund by voting; Each leader of the alliance receives governance aid from Midafi community construction fund for Midafi promotion.

Players vote to elect the leader, the leader serves the players, and the vote determines the leader's whereabouts. The players' alliance leaders have made progress together and promoted Midafi's business to flourish.

Rules:

Midafi community construction fund: 315000 Midafi will be released for 100 years.

Player voting incentive: 105000 pieces, 2.87 pieces/day

Community governance aid: 105000 pieces, 2.87 pieces/day

Midafi R&D team: 52500 pieces, 1.43 pieces/day

Midafi technical team: 52500 pcs, 1.43 pcs/day

1. The service governance cycle of the alliance leader is 60+7 days, of which 7 days are voting days.

2. 1 Midafi can be voted and withdrawn within 60+7 days.

3. Leader's governance aid composition:

1) Community governance aid: 2.87 Midafi were released per day.

2) Midafi pledged to consume 20% of Sero's energy for mining.

4. Leader's responsibilities:

1) 、 Serving Midafi players

2) . Fully promote Midafi

5. The player's voting incentive income is released to the player's voting account according to the weighted average distribution of 2.87 Midafi/day. After the voting is withdrawn, the incentive income of the account will stop being released.

6. The system code is open source, data is linked, decentralized bookkeeping, no back door, tamper proof, automatic operation, and automatic distribution.

7. The system discloses the contract rules. Players can actively participate in the contract without a recommender.

8. Contract source address: GitHub page: `,
        content2: `

Gitee page: `,
        content3: `

Netlify page: `,
        content4: `
 
9. Contract address: `,
        content5: `

10. Midafi Destroy address: `,
    },
    language: 'Language',
    changeToWallet: 'Switch to',
    changeToLang: '切換到',
    tip: {
        addrCopied: 'Address Copied',
    },
    button: {
        wallet: 'Wallet Account',
        winnerRewards: 'Rewards',
        totalSupply: 'Total Supply',
        circulation: 'Circulation',
        marketingBalance: 'Marketing Balance',
        stakingBalance: 'Staking Balance',
        fundBalance: 'Fund Balance',
        destroyAddress: 'Destroy Address',
        destroyedBalance: 'Destroyed',

        votes: 'Votes',
        candidate: 'Candidate',

        winner: 'Winner',
        vote: 'Vote',
        voted: 'Voted',
        rewards: 'Rewards',
        totalVotes: 'Total Votes',

        lastVotes: 'Winner Votes',
        lastWinner: 'Last Winner',
    },
    days: 'Day(s)',
    header: {
        rank: 'Rank',
        votes: 'Votes',
        candidate: 'Candidate',
    },
    images: {
        switch: '',
        withdraw: '',
    },
    imageLocation: 'en',
    riskWarning: 'Venture capital, cautious participation.',
    changeWallet: {
        title: 'Change Account',
        content: 'Are you sure?',
        ok: 'YES'
    },
}
export default en_US;